export const formatDateTime = (dateTimeString) => {
    // Check if the string ends with "GMT"
    if (dateTimeString.endsWith(" GMT")) {
      // Remove " GMT" from the date string
      dateTimeString = dateTimeString.replace(" GMT", "");
    }

    // Convert the date-time string to a Date object
    const dateTime = new Date(dateTimeString);

    const dateOptions = { year: "numeric", month: "long", day: "numeric" };
    const formattedDate = dateTime.toLocaleDateString("en-US", dateOptions);

    // Formatting the time
    const timeOptions = {
      hour: "numeric",
      minute: "numeric",
      second: "numeric",
      hour12: true,
    };
    const formattedTime = dateTime.toLocaleTimeString("en-US", timeOptions);

    return { date: formattedDate, time: formattedTime };
  };

  export function formatTimeAgoOrDateTime(utcTime) {
    const date = new Date(utcTime);
    const now = new Date(); // Current local time
  
    const diffInSeconds = Math.floor((now - date) / 1000); // Difference in seconds
  
    // Helper function to format local date and time
    const formatDateTime = (date) => {
      return new Intl.DateTimeFormat(undefined, {
        year: 'numeric',
        month: 'short',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
      }).format(date);
    };
  
    if (diffInSeconds < 60) {
      return `${diffInSeconds} seconds ago`;
    } else if (diffInSeconds < 3600) {
      const minutes = Math.floor(diffInSeconds / 60);
      return `${minutes} minute${minutes > 1 ? 's' : ''} ago`;
    } else if (diffInSeconds < 86400) {
      const hours = Math.floor(diffInSeconds / 3600);
      return `${hours} hour${hours > 1 ? 's' : ''} ago`;
    } else if (diffInSeconds < 604800) {
      const days = Math.floor(diffInSeconds / 86400);
      return `${days} day${days > 1 ? 's' : ''} ago`;
    } else {
      // If the difference is more than 7 days, show the date and time
      return formatDateTime(date);
    }
  }
  
  